import { useOutletContext } from "react-router-dom";
import { getDeviceIdentities } from "../api/provisioning";
import useDeviceList from "../hooks/useDeviceList";
import { consoleFeatures } from "../config/consoleFeatures";

const STATE_BADGES = {
  assigned: "badge-green",
  registered_unassigned: "badge-amber",
  revoked: "badge-red",
};

export default function Provisioning() {
  const { profile } = useOutletContext();
  const canView = profile && ["tech", "admin"].includes(profile.role);
  const { devices: rows, loading, error } = useDeviceList(getDeviceIdentities, canView);

  return <div>
    <h2 className="page-title">Provisioning</h2>
    <p className="page-sub">Registered device identities visible to your account</p>
    {!canView ? <div className="card"><div className="empty">Provisioning requires the tech or admin role.</div></div> : <div className="card">
      <h2>Authorized device identities</h2>
      <p className="desc">Device identities available to the signed-in technician or administrator.</p>
      {error && <div className="alert alert-error">{error}</div>}
      {loading && !error && <div className="spinner" />}
      {!loading && rows.length === 0 && <div className="empty">No authorized devices.</div>}
      {rows?.length > 0 && <div className="table-wrap"><table className="tbl">
        <thead><tr><th>BEID</th>{consoleFeatures.showDeviceName && <th>Name</th>}{consoleFeatures.showSharedKeyVersion && <th>Shared key ver.</th>}<th>State</th></tr></thead>
        <tbody>{rows.map((row) => <tr key={row.beid}>
          <td className="mono">{row.beid}</td>
          {consoleFeatures.showDeviceName && <td>{row.name || <span className="muted">—</span>}</td>}
          {consoleFeatures.showSharedKeyVersion && <td>{row.shared_key_version}</td>}
          <td><span className={`badge ${STATE_BADGES[row.enrollment_state] || "badge-gray"}`}>{row.enrollment_state}</span></td>
        </tr>)}</tbody>
      </table></div>}
    </div>}
  </div>;
}
